
const dev = {
    // 公众号id
    APP_ID: 'wxb953124f4e96cab8',
    // 微信授权回调地址
    WX_REDIRECT_URL: 'http://wx.jingcisi.com/login',
    // api前缀
    API_PREFIX: '/api/',
    // 登录用户信息在cookie中的Key
    USER_INFO: 'user_info',
    // 登录有效期 1小时
    COOKIE_EXPIRES: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
    // oss域名访问地址
    // OSS_DOMAIN: 'http://moguceshi.oss-cn-hangzhou.aliyuncs.com/',
    OSS_DOMAIN: 'https://jingcisi.oss-cn-hangzhou.aliyuncs.com/',
    // cdn加速地址
    CDN_DOMAIN: 'http://static.jingcisi.com/',
    // 企业微信聊天跳转链接
    CHAT_URL: 'https://work.weixin.qq.com/kfid/kfc847e2d84f494255a',
    // 联系电话
    CONTACT_TEL: '0571-87995600'
}
const prod = {
    // 公众号id
    APP_ID: 'wxb953124f4e96cab8',
    // 微信授权回调地址
    WX_REDIRECT_URL: 'http://wx.jingcisi.com/login',
    // api前缀
    API_PREFIX: '/api/',
    // 登录用户信息在cookie中的Key
    USER_INFO: 'user_info',
    // 登录有效期 1小时
    COOKIE_EXPIRES: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
    // oss域名访问地址
    OSS_DOMAIN: 'https://jingcisi.oss-cn-hangzhou.aliyuncs.com/',
    // cdn加速地址
    CDN_DOMAIN: 'http://static.jingcisi.com/',
    // 企业微信聊天跳转链接
    CHAT_URL: 'https://work.weixin.qq.com/kfid/kfc847e2d84f494255a',
    // 联系电话
    CONTACT_TEL: '0571-87995600'
}

module.exports = process.env.NODE_ENV === 'production' ? prod : dev